// src/components/Hero.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
// --- 1. Import Framer Motion's 'motion' ---
import { motion } from 'framer-motion';

// --- Import the Video Asset ---
import HeroVideo from '../assets/videos/hero-video.mp4'; 

const Hero = () => {
  return (
    <section className='hero-section'>
      
    
      <video className="hero-video-bg" autoPlay loop muted playsInline>
        <source src={HeroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* ----------------------------- */}

      {/* 2. Replace the div with motion.div and add animation props */}
      <motion.div 
        className='hero-content'
        
        // --- 3. Define the starting state (hidden and 50px lower) ---
        initial={{ opacity: 0, y: 50 }} 
        
        // --- 4. Define the final state (visible and in original position) ---
        animate={{ opacity: 1, y: 0 }} 
        
        // --- 5. Define the transition properties ---
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        
        <h1 className='hero-headline'>
          Personalized resources for who you aspire to become.
        </h1>

        <p className='hero-subtext'>
          Reduce information overload and find clear, structured guidance tailored to your unique goals, experience, and learning preferences.
        </p>

        <Link to='/onboarding' className='btn-primary hero-cta'>
          Start Your Journey
        </Link>
      </motion.div>
    </section>
  );
};

export default Hero;